import React from 'react';

export class Error500Screen extends React.Component {
  render() {
    return (
      <div className="d-flex" style={{ height: "100vh" }}>
        <div className="big-error-w" style={{ maxWidth: "100%", margin: "auto" }}>
          <h1>
            500
          </h1>
          <h5>
            Internal Server Error
          </h5>
          <h4>
            Oops, Something is broken...
          </h4>
        </div>
      </div>
    )
  }
};
